import { AddBox, Delete, Edit } from "@mui/icons-material";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormLabel, Modal, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import axiosInstance from "../../../utils/axiosInstance";

const Users = () => {
    const [users, setUsers] = useState([
        {
            user_id: 0,
            name: '',
            email: '',
            phone: '',
            is_member: false,
            role: '',
            createdAt: '',
        }
    ]);
    const [user, setuser] = useState({
        user_id: 0,
        name: '',
        email: '',
        phone: '',
        role: '',
        password: '',
    })

    const [selectedUser, setSelectedUser] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const getUsersRef = useRef()

    const filteredUsers = users.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()) || user.phone.toLowerCase().includes(searchQuery.toLowerCase()) || user.role.toLowerCase().includes(searchQuery.toLowerCase()) || user.createdAt.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedUsers = filteredUsers.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        console.log(event)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Delete confirmation handlers
    const handleOpenDeleteModal = (user) => {
        setSelectedUser(user);
        setIsDeleteModalOpen(true);
    };

    const handleOpenEditModal = (user) => {
        setSelectedUser(user);
        setIsEditModalOpen(true);
    };

    const handleDeleteUser = () => {
        setUsers([]);
    }

    const handleAddUser = async() => {
        setOpen(true);

        await axiosInstance.post(`auth/register`, user, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            setMessage(`Success, successfully added ${user.name}`)
            if(getUsersRef.current) getUsersRef.current()
            setTimeout(() => {
                setOpen(false);
                setIsAddModalOpen(false)
            }, 2000)
        }).catch((error) => {
            setOpen(false);
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
        })
    }

    const handleEditUser = async() => {
        setOpen(true);

        await axiosInstance.put(`auth/user/${selectedUser.user_id}`, selectedUser).then((response) => {
            setMessage(`Success, successfully edited ${selectedUser.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getUsersRef.current) getUsersRef.current()
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            setOpen(false);
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
        })
    }

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        const getUsers = async () => {
            await axiosInstance.get(`auth/users`).then((response) => {
                setUsers(response.data.users);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No users found") {
                    setUsers([]);
                } else{
                    setUsers([]);
                }
            })
        }

        getUsers()
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage users</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add user</Button></div>
            </div>
            <br />

            <div className="p-4">
                <TextField label="Search for a user by name, email, role, phone, date registerd" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell>Date registered</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedUsers.map((user, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.phone}</TableCell>
                                    <TableCell>{user.role}</TableCell>
                                    <TableCell>{user.createdAt.slice(0,10)}</TableCell>
                                    <TableCell className="flex gap-2">
                                        {/* <RemoveRedEye color="success" className="cursor-pointer" /> */}
                                        <Edit color="primary" onClick={() => handleOpenEditModal(user)} className="cursor-pointer" />
                                        <Delete color="error" onClick={() => handleOpenDeleteModal(user)} className="cursor-pointer" />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredUsers.length === 0 && <TableRow className="text-center"><TableCell colSpan={8}>No user found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredUsers.length]}
                        component="div"
                        count={filteredUsers.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the user name "
                        {selectedUser.name ? selectedUser.name : "Anonymus"}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteUser} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Book Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Edit user</h2>
                    <div>
                        <FormLabel>Enter name</FormLabel>
                        <TextField variant="outlined" fullWidth value={selectedUser.name} onChange={(e) => setSelectedUser((prev) => ({ ...prev, name: e.target.value }))} type="text" style={{ marginBottom: 10 }} />
                        <FormLabel>Phone number</FormLabel>
                        <TextField variant="outlined" fullWidth value={selectedUser.phone} onChange={(e) => setSelectedUser((prev) => ({ ...prev, phone: e.target.value }))} type="tel" style={{ marginBottom: 10 }} />
                        <FormLabel>Email address</FormLabel>
                        <TextField variant="outlined" fullWidth value={selectedUser.email} onChange={(e) => setSelectedUser((prev) => ({ ...prev, email: e.target.value }))} type="email" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" fullWidth variant="outlined">
                            Cancel
                        </Button>
                        <Button color="primary" fullWidth variant="outlined" onClick={handleEditUser}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Member Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Add User</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={user.name} onChange={(e) => setuser((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Enter name" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={user.phone} onChange={(e) => setuser((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Phone number" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={user.email} onChange={(e) => setuser((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Email address" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={user.role} onChange={(e) => setuser((prev) => ({ ...prev, role: e.target.value }))} type="text" label="Role" style={{ marginBottom: 10 }} />                      
                        <TextField variant="outlined" fullWidth value={user.password} onChange={(e) => setuser((prev) => ({ ...prev, password: e.target.value }))} type="password" label="Password" style={{ marginBottom: 10 }} />                      
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddUser}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Users